export enum PickupTypes {
  PENDIENTE="Pendiente",
  AGENDADA="Agendada",
  RECOGIDA="Recogida",
  CANCELADA="Cancelada",
  INCOMPLETA="Incompleta",
  EN_TRANSITO = "En transito",
  PICKUP = "Recogida",
  IN_ORIGIN_WAREHOUSE = "En bodega origen",
  TO_DISPATCH = "En despacho",
  IN_DESTINATION_WAREHOUSE = "En bodega destino",
  TO_HAULAGE = "En reparto",
  SHIPMENT_DELIVERED = "Entregada"
}

export default PickupTypes;
